import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_USER_CREDIT_PROVIDERS_ACTION_TYPE } from '../actions';

const initialState = {};

const subCompanyUserCreditProvidersReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case SUB_COMPANY_USER_CREDIT_PROVIDERS_ACTION_TYPE.GET_USER_CREDIT_PROVIDERS:
        return { ...state, ...payload };

      case SUB_COMPANY_USER_CREDIT_PROVIDERS_ACTION_TYPE.UPDATE_USER_CREDIT_PROVIDER:
        draft[meta.userId] = payload;
        break;

      case SUB_COMPANY_USER_CREDIT_PROVIDERS_ACTION_TYPE.DELETE_USER_CREDIT_PROVIDER:
        delete draft[meta.userId];
        break;

      case SUB_COMPANY_USER_CREDIT_PROVIDERS_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyUserCreditProvidersReducer;
